__webpack_require__.p = "/mailbox-inbox-select/system-email-templates/";